"use strict";
define([
    'jquery',
    'underscore',
    'navigation',
    'backboneRadix',
    'text-loader!common/dialog-bs/layout.tpl',
    'store',
    'mount-vue-component',
    'common',
    'main',
    'vue',
], function($, _, navigation, Backbone, html, store, mount, common, main, vue)
{
    $("body").append(html);

    return {

        show: function(title,html,footer)
        {
            var dialog = $("#module-dialog");
            dialog.find(".modal-title").empty().append(title);
            dialog.find(".modal-body").empty().append(html);
            dialog.find(".modal-footer").empty().append(footer);
            dialog.modal("show");
        },
        
        async showComponent(path, title, state={}, options={})
        {
            var dialog = $("#module-dialog");
            dialog.find(".modal-body").append("<div></div>")
            const cont = dialog.find(".modal-body div")
            
            $("#module-dialog .modal-dialog").draggable({
               handle: ".modal-header"
            });
            
            var proxy = _.extend({
              close: function() { dialog.modal("hide") }
            }, Backbone.Events);
            
            var modCtor = await navigation.promiseLoadModule(path)

            const app = main.getApp()

            const compName = path.split('/').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join('')

            if (!app.component(compName))
            {
              app.component(compName, modCtor)
            }
            
            const mod = app.component(compName)
            
            let compState = vue.reactive({})
            common.deepAssign(compState, state)

            const el = cont[0]            
            $(el).empty()
            
            const proxy2 = {
              setTitle(title) { dialog.find(".modal-title").empty().append(title) },
            }

            const { vNode, destroy, el2 } = mount.mount(mod,
                  {props: {state: compState, dialog: proxy2}, element: el, app})

            if (options.zIndex)
            {
              $(dialog).css('z-index', options.zIndex)
            }

            if (options.width)
            {
               $(dialog).find(".modal-dialog").css({
                 'max-width': options.width + "vw",
                 'width': options.width + "vw" + " !important"
               })
            }
            
            dialog.find(".modal-title").empty().append(title);
                
            dialog.off().on("hide.bs.modal", function()
            {
              proxy.trigger("close");
              dialog.find(".modal-body").empty()
              $(dialog).css('pointer-events', "auto");
              destroy()
            });

            const params = { show: true, keyboard: true }

            if (options.disable_modality)
            {
              // Разрешаем выделять текст под модальным окном
              params.backdrop = false
              $(dialog).css('pointer-events', "none");
            }

            dialog.modal(params)
            
            return proxy;
        },

        showModule: function(mod,options,state)
        {
            if (_.isUndefined(state))
            {
              state = options;
              options = undefined;
            }
           
            state = state || {};
            options = options || {}; 

            var dialog = $("#module-dialog");
            var body = dialog.find(".modal-body");
            
            var proxy = _.extend({
              close: function() { dialog.modal("hide") }
            }, Backbone.Events);

            navigation.promiseCreateModule(mod,body,options).then(function()
            {
                if (!mod.detached)
                {
                    mod.detach();
                }
                mod.attachTo(body);
                mod.setState(state);
                
                if (options.zIndex)
                {
                  $(dialog).css('z-index', options.zIndex)
                }

                dialog.find(".modal-title").empty().append(mod.title);
                
                dialog.off().on("hide.bs.modal", function()
                {
                  mod.detach();
                  proxy.trigger("close");
                });

                dialog.modal({keyboard: true})
            });
            
            return proxy;
        },
        
        close: function()
        {
          $("#module-dialog").modal("hide");
        },

    };
});
        